import Icon from "@mui/icons-material/EventTwoTone";
import { EventEdit } from "./EventEdit";
import { EventCreate } from "./EventCreate";
import { EventShow } from "./EventShow";

export default {
  edit: EventEdit,
  create: EventCreate,
  show: EventShow,
  icon: Icon,
  label: "Events",
  options: { label: "Event" },
  name: "events",
};
